<template>
    <section class="c-mvp-streaming">
        <y-loading
            v-if="!streamingData"
            :active="$wait.is('loading-streaming-mvp')"
            size="60"
            height="467px"
            position="relative"
        />
        <div
            v-else
            class="c-mvp-streaming--loaded"
        >
            <div class="c-mvp-streaming__title">
                <h2>
                    {{ streamingData.title }}
                </h2>
            </div>
            <div class="c-mvp-streaming__content">
                <div class="streaming-content">
                    <div class="content-text">
                        <div
                            class="content-list"
                            v-html="streamingData.text"
                        />
                    </div>

                    <div class="video-container">
                        <y-tutorial-vide-card
                            iframe
                            iframe-field="field1"
                            :content="streamingData"
                            blur-background
                        />
                    </div>
                </div>

                <div class="c-mvp-streaming__action">
                    <y-button
                        :tag="isLink(streamingData.custom['button-link']) ? 'a' : 'router-link'"
                        :href="streamingData.custom['button-link']"
                        :to="streamingData.custom['button-link']"
                        :content="streamingData.custom['button-title']"
                        color="primary"
                        size="medium"
                        flat
                        :no-padding="true"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';
    import YTutorialVideCard from '@/modules/home/components/TryItYourself/Index.vue';

    export default {
        name: 'MVPStreaming',

        components: {
            YTutorialVideCard,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                streamingData: null,
            };
        },

        computed: {
            /**
             *
             * Whether the device is desktop or not
             *
             * @returns {boolean}
             */
            isDesktop() {
                return this.$mq === 'lg' || this.$mq === 'xlg';
            },
        },

        /**
         *
         * @inheritDoc
         */
        created() {
            this.fetch();
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-streaming-mvp');
                const streaming = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'mvp2',
                    including: ['id', 'title', 'image', 'synopsis', 'albums', 'custom', 'text'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([streaming])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.streamingData = responses[0].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-streaming-mvp');
                    });
            },
        },
    };

</script>

<style lang="scss" src="./streaming.scss"/>
